<template>
  <generic-modal
    :height="loaderDim.height"
    :width="loaderDim.width"
    :modalClass="loaderDim.modalClass"
    :overflowNotNeeded="true"
    v-if="isLoading || isMapScreenLoading"
  >
    <template v-slot:header></template>
    <template v-slot:body>
      <div class="loader">
        <!-- <i class="hkfi-logo-hongs"></i> -->
      </div>
    </template>
    <template v-slot:footer>
      <div class="fs-16 bold color-white txt mt5" v-if="text.length > 0">
        {{ text }}
      </div>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { keyMapsMutation } from "../helpers/storeKeys";
export default {
  components: { GenericModal },
  name: "Preloader",
  props: {
    color: {
      type: String,
      default: "#41b883",
    },
    scale: {
      type: Number,
      default: 1,
    },
    transparent: {
      default: true,
      required: false,
    },
    text: {
      default: "Please wait...",
      required: false,
      type: String,
    },
  },
  mounted() {
    document.body.classList.add("body-stop-scroll-mobile");
    setTimeout(
      () => this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false),
      3000
    );
  },
  beforeDestroy() {
    document.body.classList.remove("body-stop-scroll-mobile");
  },
  data() {
    return {
      loaderDim: {
        height: "100vh",
        width: "100vw",
        modalClass: "loader-wrap",
        modalClassTransparent: "loader-wrap transparent",
      },
    };
  },
  computed: {
    isLoading() {
      setTimeout(
        () => this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false),
        3000
      );
      return this.$store.state.Loader.isLoading;
    },
    isMapScreenLoading() {
      return this.$store.state.Loader.isMapScreenLoading;
    },
  },
};
</script>

<style></style>
